// extracted by mini-css-extract-plugin
export default {"Test":"TablePaginationActions_Test__ou62V"};